import React from "react";
import styled from "styled-components";
import hilda from '../../assets/img/HildaDialogue.png';
import { Icon, Title } from "../../components/MiniComponents";

const OurGameRoot = styled.section`
    position: relative;
    display: flex;
    text-align:center;
    align-items: center;
    text-align:center;
    justify-content: center;
    background: linear-gradient(to top, #111, #ffffff0d);
    padding-top: 1em;
    @media (max-width: 768px){
        flex-direction: column;
    }
`

const SideImage = styled.img`
    width: 17em;
    border: solid 2px black;
    border-radius: 33px;
    background: #00000063;
    flex: 0;
    margin: 4em;
    @media (max-width: 768px){
        display: none;
    }
`

const OurGameDescription = styled.div`
    display: inline-block;
    flex: 1;
    max-width: 45em;
    margin-left:2em;
    @media (max-width: 768px){
        margin: 0em;
        padding-top: 3em;
    }
`
const Description = styled.div`
    @media (max-width: 768px){
        padding: 0 1em;
        fontSize: '1.2em'
    }
`

const OurGameStore = styled.div`
    display: flex;
    max-width: 17em;
    padding: 5em;
    flex: 1;    
    @media (max-width: 768px){
        max-width: initial;
        margin-left: 0em;
        padding: 0 0 2em 0;
    }
`

const GooglePlayButton = styled.img`
    width: 17em;
`


const OurGame = () => {
    return (
        <OurGameRoot id="ourGame">
            <SideImage src={hilda}></SideImage>
            <OurGameDescription>
                <Title>Notre jeu</Title>
                <Description>
                    <p>The Darkest Tower Defense est un jeu indépendant de stratégie dont
                        l'objectif est d'empêcher la horde des Sans-Âmes d'atteindre la
                        Sainte-Arche, dernier rempart de l'humanité.</p>
                    <p>Gagnez des runes et dépensez-les dans un arbre de compétences pour élargir
                        votre arsenal de défense. Choisirez-vous la voie de l'Ombre ou de la Lumière ?</p>
                </Description>
            </OurGameDescription>
            <OurGameStore>
                <a href='https://play.google.com/store/apps/details?id=com.FarlandsStudio.DarkestTowerDefense&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                    <GooglePlayButton alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' />
                </a>
            </OurGameStore>
        </OurGameRoot>
    )
};
export default OurGame;


// WEBPACK FOOTER //
// ./src/pages/OurGame/OurGame.jsx